import { Routes } from "@angular/router";
import { SamplepoListingComponent } from "./components/samplepo-listing/samplepo-listing.component";
import { SamplepoSummaryComponent } from "./components/samplepo-summary/samplepo-summary.component";
import { SamplepoComponent } from "./samplepo.component";
import { PoEmailComponent } from "./components/po-email/po-email.component";

export const samplePORoutes: Routes = [
  { path: "", component: SamplepoListingComponent },
  {
    path: "samplepo-summary/:samplePONumber",
    component: SamplepoSummaryComponent,
  },
  { path: "add-samplepo", component: SamplepoComponent },
  { path: "po-email/:poNumber", component: PoEmailComponent },
];
